























import { getRange } from '@/libs/time';
import CronjobServices from '@/services/cronjob';
import DatajobServices from '@/services/datajob';
import { Vue, Component, Watch } from 'vue-property-decorator';
@Component
export default class Job1 extends Vue {
  bread = [{ name: '作业运行管理' }, { name: '作业类型运行总览' }];
  jobSrv = new CronjobServices();
  datajobSrv = new DatajobServices();

  columns = [
    { title: '作业处理数据日期', dataIndex: 'job_group_name_ex' },
    { title: '作业总数', dataIndex: 'total' },
    {
      title: '作业最终执行状态',
      children: [
        { title: '未处理', dataIndex: 'totalStatus0' },
        { title: '处理中', dataIndex: 'totalStatus1' },
        { title: '处理成功', dataIndex: 'totalStatus2' },
        { title: '处理失败', dataIndex: 'totalStatus3' }
      ]
    },
    {
      title: '作业执行信息',
      children: [
        { title: '作业失败次数', dataIndex: 'totalRecordStatus3' },
        { title: '作业重跑次数', dataIndex: 'totalRecordType2' },
        { title: '作业补跑次数', dataIndex: 'totalRecordType3' }
      ]
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 90,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  date: any = getRange('week');
  created() {
    let query = this.$route.query || {};
    if (query.startTime && query.endTime) {
      this.date = [query.startTime, query.endTime];
    }
    this.getList();
  }

  list: any[] = [];
  async getList() {
    let [startTime, endTime] = this.date;
    this.list = await this.jobSrv.getTotalGroupRecord({ startTime, endTime });
    let datalist = await this.datajobSrv.getTotalGroupRecord({ startTime, endTime });
    if (datalist && datalist.length > 0) {
      this.list = this.list.concat(datalist);
    }
  }

  routeToRecord(record: any) {
    let { job_group_name } = record;
    let link = '/jobs/record/' + job_group_name;
    let query = {
      startTime: this.date[0],
      endTime: this.date[1]
    };
    return {
      path: link,
      query
    };
  }

  @Watch('date')
  onDateChange() {
    this.getList();
  }
}
